module.exports = __webpack_public_path__ + "img/UsuarioSinUsuEnActivacion.55ca20d2.svg";